import React, { Component} from "react";
import { withRouter } from "react-router-dom";
import DeploymentMessage from "../../../shared_elements/components/DeploymentMessage";
import DashboardAnalytics from "./DashboardAnalytics";

function DashboardWrapper(HocComponent, extraProps = {}) {
	class EnhancedComponent extends Component {
		render() {
			return (
				<div className="camo-dashboard">
					<DeploymentMessage />
					<>
						<DashboardAnalytics />
						<HocComponent {...this.props} {...extraProps} />
					</>
				</div>
			);
		}
	}

	return withRouter(EnhancedComponent);
}

export default DashboardWrapper;
